import { useNavigate } from "react-router-dom";
import { DashboardRoutes } from "@/router";
import { isMobileBusinessRegisterURL } from "@/utils/isRegisterURL";
import { Dispatch, SetStateAction } from "react";
import { settingsBusinessAtom } from "../../state";
import { useImmerAtom } from "jotai-immer";

type SaveToReduxProps = {
  fieldName: keyof ReturnType<(typeof settingsBusinessAtom)["read"]>["mobileFormEdit"];
  fieldValue: any;
  setIsDrawerOpen: Dispatch<SetStateAction<boolean>>;
  nextUrlForMobileRegisterURL: string;
  nextUrlForEdit?: string;
};

export function useSaveToRedux() {
  const isRegisterURL = isMobileBusinessRegisterURL();
  const [, setSettingsBusinessState] = useImmerAtom(settingsBusinessAtom);

  const navigate = useNavigate();
  const { settings } = DashboardRoutes;

  const saveToRedux = async ({
    nextUrlForMobileRegisterURL,
    nextUrlForEdit,
    fieldName,
    fieldValue,
    setIsDrawerOpen,
  }: SaveToReduxProps) => {
    setSettingsBusinessState((draft) => {
      draft.mobileFormEdit[fieldName] = fieldValue;
    });
    setIsDrawerOpen(false);

    if (isRegisterURL) {
      navigate(nextUrlForMobileRegisterURL);
    } else {
      navigate(nextUrlForEdit ?? settings.business.root.url);
    }
  };

  return { saveToRedux };
}
